<template>
  <div class="settings time-zone" id="timezone">
    <div style="float: left">
      <h1>
        {{ $t("langcfg.txtTimeZone") }}
      </h1>
      <div class="time-zone-top2">
        <!-- <el-select v-model="zone" class="time-zone-select" placeholder="">
          <el-option
            v-for="item in timezones"
            :key="item.value"
            :label="$t(`timezone.${item.label}`)"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-select
          v-model="objSel"
          value-key="label"
          ref="city"
          placeholder=""
          filterable
          clearable
          class="time-zone-select standby-time"
          @change="cityChanged"
        >
          <el-option
            v-for="item in cities"
            :key="item.value + ' ' + item.zonevalue"
            :label="
              $t(`timezone.${item.label}`).replace('_', ' ') +
              ' (' +
              $t(`timezone.${item.zonelabel}`) +
              ')'
            "
            :value="item"
          >
          </el-option>
        </el-select>
        <button class="time-zone-edit" @click="setTimezone">
          {{ $t("langcfg.txtOK") }}
        </button>
      </div>
    </div>
    <div style="clear: both"></div>
    <div style="margin-top: 120px"></div>
    <div style="margin-top: 100px">
      <h1>{{ $t("langcfg.txtEditTime") }}</h1>
      <div class="time-zone-top2" id="time-zone">
        <el-date-picker
          style="width: 450px; float: left"
          v-model="currentDatetime"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <button class="time-zone-edit" @click="setDatetime">
          {{ $t("langcfg.txtOK") }}
        </button>
      </div>
    </div>
    <div style="margin-top: 180px"></div>
    <h1>{{ $t("langcfg.txtSleepTime") }}</h1>
    <div class="time-zone-top2" id="time-zone">
      <el-select v-model="screenSaveTime" class="time-zone-select standby-time">
        <el-option
          v-for="item in screenSaveTimes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <button class="time-zone-edit" @click="setStandyTime">
        {{ $t("langcfg.txtOK") }}
      </button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import fileSys from "../../../../src/fileoprators/fileSystem";
import { saveSettings } from "../../../settings";
import EVENTS from "../../../bus";
import { Message } from "../../../mixins";
import { cloneObj, getSystemTime } from "../../../shared/utils";
export default {
  name: "TimeZone",
  data() {
    return {
      zone: "",
      timezones: {},
      city: "",
      value: "",
      value2: "",
      currentDatetime: "",
      timezone: "",
      // 具体时区
      screenSaveTime: 5,
      screenSaveTimes: [
        { label: `5 ${this.$t("langcfg.txtMinates")}`, value: 5 },
        { label: `15 ${this.$t("langcfg.txtMinates")}`, value: 15 },
        { label: `30 ${this.$t("langcfg.txtMinates")}`, value: 30 },
        { label: `60 ${this.$t("langcfg.txtMinates")}`, value: 60 },
        { label: this.$t("langcfg.txtNever"), value: -1 }
      ],
      cities: [],
      objSel: ""
    };
  },
  mixins: [Message],
  computed: {
    // cities: function () {
    //   console.log('computed', this.zone)
    //   if (this.timezones && this.timezones[this.zone]) {
    //     return this.timezones[this.zone].cities.concat()
    //   } else {
    //     return []
    //   }
    // }
  },
  watch: {
    // zone: function () {
    //   if (!this.timezones || !this.timezones[this.zone]) return
    //   if (this.timezones[this.zone].cities.filter(item => {
    //     return item.value === window.settings.timeZone.city
    //   }).length > 0) {
    //     this.city = window.settings.timeZone.city
    //   } else {
    //     this.city = this.timezones[this.zone].cities[0].value
    //   }
    // }
  },
  methods: {
    addTouchEvent() {
      const event = new Event("input", { bubbles: false });
      const self = this;
      this.$nextTick(() => {
        // self.$refs.city.$children[0].$el.addEventListener('touchend', (e) => {
        //   // e.preventDefault()
        //   // e.stopPropagation()
        //   // this.city = ''
        //   self.$bus.$emit(EVENTS.spreadKeyBoard, self.objSel, (value) => {
        //     self.objSel = value
        //     self.$refs.city.handleQueryChange(value)
        //   })
        // })
        self.$refs.city.$children[0].$el.addEventListener("click", (e) => {
          // e.preventDefault()
          // e.stopPropagation()
          // this.city = ''
          self.$bus.$emit(EVENTS.spreadKeyBoard, self.objSel, (value) => {
            self.objSel = value;
            self.$refs.city.handleQueryChange(value);
          });
        });
      });
    },
    getTimezones() {
      fileSys.getTimezones((err, timezones) => {
        if (!err) {
          this.timezones = timezones;
          let keys = Object.keys(timezones);
          this.cities = [];
          let selected = {};
          keys.forEach((key) => {
            let items = timezones[key].cities.filter((item) => {
              return item && item.label && item.value;
            });
            items.forEach((val) => {
              val.zonelabel = timezones[key].label;
              val.zonevalue = timezones[key].value;

              if (val.value === this.city && val.zonevalue === this.zone) {
                selected =
                  this.$t(`timezone.${val.label}`).replace("_", " ") +
                  " (" +
                  this.$t(`timezone.${val.zonelabel}`) +
                  ")";
              }
            });
            this.cities = this.cities.concat(items);
          });
          // this.cities = this.timezones[this.zone]
          // console.log(this.cities)
          this.objSel = selected;
        }
      });
    },
    getDatetime() {
      this.currentDatetime = getSystemTime("-", " ", ":");
    },
    setStandyTime() {
      window.settings.screensavetime = this.screenSaveTime;
      saveSettings(window.settings);
      this.$bus.$emit(EVENTS.hideScreenSaver, this.screenSaveTime);
      this.message(this.$t("langcfg.txtEditSuccess"), "success");
    },
    //  修改时间
    setDatetime() {
      fileSys.setDatetime(this.currentDatetime, (error) => {
        console.log("err", error);
        if (error) {
          this.message(this("langcfg.txtEditFail"), "error");
        } else {
          this.$bus.$emit("updateTime");
          this.message(this.$t("langcfg.txtEditSuccess"), "success");
        }
      });
    },
    //  修改时区
    setTimezone() {
      this.timezone = this.zone + "/" + this.city;
      fileSys.setTimezone(this.timezone, (error) => {
        if (!error) {
          window.settings.timeZone.zone = this.zone;
          window.settings.timeZone.city = this.city;
          this.getDatetime();
          saveSettings(window.settings);
          this.message(this.$t("langcfg.txtEditSuccess"), "success");
          this.$bus.$emit("updateTime");
        } else {
          this.message(this.$t("langcfg.txtEditFail"), "error");
        }
      });
    },
    cityChanged(item) {
      if (item && item.label) {
        this.objSel =
          this.$t(`timezone.${item.label}`).replace("_", " ") +
          " (" +
          this.$t(`timezone.${item.zonelabel}`) +
          ")";
        this.city = item.value;
        this.zone = item.zonevalue;
      } else {
        this.objSel = this.city = this.zone = "";
      }
    }
  },
  created() {
    const { zone, city } = window.settings.timeZone;
    this.zone = zone;
    this.city = city;
  },
  mounted() {
    this.screenSaveTime = window.settings.screensavetime || 5;
    this.getTimezones();
    this.getDatetime();
    this.addTouchEvent();
  }
};
</script>
<style lang="less" scoped>
.settings {
  // margin-left: 30px;
  font-size: 23px;
  color: white;
}
.logo-img {
  width: 350px;
}
.el-radio {
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
#time-zone {
  position: relative;
  z-index: 10;
}
.time-zone-select {
  font-size: 22px;
  width: 300px;
  float: left;
}
/deep/.el-picker-panel__footer {
  display: none;
}
.time-zone-edit {
  padding: 0px 12px;
  font-size: 25px;
  height: 50px;
  background-color: #3f6ee8;
  border-radius: 4px;
  border: none;
  outline: none;
  resize: none;
  color: white;
  float: left;
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  min-width: 150px;
  z-index: 99;
}
.edit2-bgc {
  background: #ee86cf;
}
.time-zone-top {
  margin-top: 50px;
}
.time-zone-top2 {
  margin-top: 30px;
}
.standby-time {
  width: 450px;
}
</style>
<style lang="less">
#timezone {
  .el-input__icon {
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/TimeZone.vue